function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageAdd = function SvgImageAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M41.2 40.4H7.3c-2.2 0-3.9-1.8-3.9-3.9V13.1c0-2.2 1.8-3.9 3.9-3.9h33.9c2.2 0 3.9 1.8 3.9 3.9v23.5c0 2.1-1.8 3.8-3.9 3.8zM12.5 13.7c-2.5 0-4.6 2-4.6 4.6s2 4.6 4.6 4.6 4.6-2 4.6-4.6-2.1-4.6-4.6-4.6zM8.6 35.2h31.3v-9.1L32.8 19c-.4-.4-1-.4-1.4 0l-11 11-4.5-4.5c-.4-.4-1-.4-1.4 0l-5.8 5.8v3.9z",
    style: {
      fill: "#666"
    }
  }));
};
export default SvgImageAdd;